export default __webpack_public_path__ + "static/media/handprint-22-23-page.67eb37e9.png";